/**
 * How wide the docked pane is. A width is a preference about this browser's
 * window, not about the data, so it lives beside the grid's column widths:
 * in local storage, per browser.
 */
const KEY = 'nemo.pane.width';

export const PANE_MIN = 420;
export const PANE_MAX = 720;
export const PANE_DEFAULT = 520;

export function clampPaneWidth(width: number): number {
  return Math.min(PANE_MAX, Math.max(PANE_MIN, Math.round(width)));
}

export function readPaneWidth(): number {
  try {
    const stored = window.localStorage.getItem(KEY);
    if (stored === null) return PANE_DEFAULT;
    const width = Number(stored);
    return Number.isFinite(width) ? clampPaneWidth(width) : PANE_DEFAULT;
  } catch {
    // A private window or a cleared store is simply no preference.
    return PANE_DEFAULT;
  }
}

export function writePaneWidth(width: number): void {
  try {
    window.localStorage.setItem(KEY, String(width));
  } catch {
    // Nothing here is worth failing a drag over.
  }
}
